import momentJalaali from "moment-jalali";
import { Fragment, useEffect, useState } from "react";
import { Button, Col, Form, FormGroup, Row, Table } from "react-bootstrap";
import { Archive, Check2Square, CheckLg, File, FileEarmark, FileEarmarkBreak, FileEarmarkDiff, FileEarmarkEasel, FileEarmarkPost, List } from "react-bootstrap-icons";
import NewNumberInput from "../../../Components/NewNumberInput";
import { keyIsLetterOrNumber, setErrorDialog } from "../../../store/api/CommonFunctions";
import ModalAccountLevel3 from "../../../Components/Modals/ModalAccountLevel3";
import { getMainCompanies, getStaffShare, updateServicePayments, archiveService, removeArchiveService } from "../../store/api/Services";
import Loader from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import DatePicker from "react-datepicker2";
import ModalServiceAgencyAccountReport from "./ModalServiceAgencyAccountReport";
import { getDocumentIDByAttachment } from "../../../Accounting/store/api/DocumentsAPI";
import ModalSelectCustomer from "../../../Components/Modals/ModalSelectCustomer";

const ServiceAccountings = (props) => {
    const { serviceInfo, setServiceInfo, checkedIn, fromModal } = props;
    const dispatch = useDispatch();
    const [mainCompanies, setMainCompanies] = useState([]);
    const [modalAgencyAccReport, setModalAgencyAccReport] = useState({ show: false });
    const { staffPayments, fieldList, systemSettings } = useSelector(state => { return { staffPayments: state.service.serviceStaffPayments, fieldList: state.UserReducer.pageFieldList, systemSettings: state.SystemSettingsReducer.systemSettings } });
    const [targetAccount, selectTargetAccount] = useState({ AccountID: serviceInfo?.TargetAccountID, AccountCat: serviceInfo?.TargetAccountCat, AccountName: serviceInfo?.TargetAccountName });
    const [popAccLevel3, setPopAccLevel3] = useState({ show: false });
    const [popCustomer, setPopCustomer] = useState({ show: false });
    const [account4Deposit, selectAccount4Deposit] = useState({ AccountID: serviceInfo?.AccountID4Deposit, AccountCat: serviceInfo?.AccountCat4Deposit, AccountName: serviceInfo?.AccountName4Deposit });
    const staffSharesInfo = {
        StaffMainCoAmountPaymentPercentShare: serviceInfo.StaffMainCoAmountPaymentPercentShare,
        StaffMainCoAmountPaymentFixAmountShare: serviceInfo.StaffMainCoAmountPaymentFixAmountShare
    }
    const sType1DocCreationType = Array.isArray(systemSettings) ? Number(systemSettings?.find(s => s.SettingName === "Services_Type1_AccountingDocumentCreationTypeID")?.SettingValue ?? -1) : -1;
    const sType2DocCreationType = Array.isArray(systemSettings) ? Number(systemSettings?.find(s => s.SettingName === "Services_Type2_AccountingDocumentCreationTypeID")?.SettingValue ?? -1) : -1;
    const sType3DocCreationType = Array.isArray(systemSettings) ? Number(systemSettings?.find(s => s.SettingName === "Services_Type3_AccountingDocumentCreationTypeID")?.SettingValue ?? -1) : -1;
    const nationalCodeIsRequired = Array.isArray(systemSettings) && systemSettings.find(s => s.SettingName === "NationalCodeIsRequired")?.SettingValue.toLowerCase() === "true";
    const showDocDate = ((sType1DocCreationType === 3 && !(Number(serviceInfo?.AgencyID) > 0)) ||
        ((sType2DocCreationType === 3 && Number(serviceInfo?.AgencyID) > 0 && serviceInfo?.ReceptionInAgent?.toString().toLowerCase() === "true")) ||
        ((sType3DocCreationType === 3 && Number(serviceInfo?.AgencyID) > 0 && serviceInfo?.ReceptionInAgent?.toString().toLowerCase() !== "true")));

    const [submitData, setSubmitData] = useState({
        InitPay: Number(serviceInfo?.AmountCustomerShouldPay ?? 0) + Number(serviceInfo?.Discount ?? 0) - Number(serviceInfo?.TaxAmount ?? 0),
        Discount: Number(serviceInfo?.Discount ?? 0),
        TaxAmount: Number(serviceInfo?.TaxAmount ?? 0),
        AmountCustomerShouldPay: Number(serviceInfo?.AmountCustomerShouldPay ?? 0),
        CustomerPayment: Number(serviceInfo?.CustomerPayment ?? 0),
        TargetAccountCat: serviceInfo?.TargetAccountCat,
        TargetAccountID: serviceInfo.TargetAccountID,
        AccountID4Deposit: serviceInfo?.AccountID4Deposit,
        AccountCat4Deposit: serviceInfo?.AccountCat4Deposit,
        Deposit: serviceInfo?.Deposit,
        PaymentDeadline: serviceInfo?.PaymentDeadline,
        MainCompanyID: serviceInfo?.MainCompanyID,
        MainCompanyAccountTransactionIndex: serviceInfo?.MainCompanyAccountTransactionIndex,
        MainCompanyPaymentStaffShare: serviceInfo?.MainCompanyPaymentStaffShare,
        AmountMainCompanyPays: serviceInfo?.AmountMainCompanyPays

    });
    function checkFieldPermission(fieldName, actionType) {
        let result = true;

        let field = fieldList?.find(f => (f.PageName?.toLowerCase() === serviceInfo?.ServiceType.toLowerCase()) && f.Name.toLowerCase() === fieldName?.toLowerCase());

        if (actionType === "Read" && field) {
            result = field.IsRead === true;
        }
        if (actionType === "Edit" && field) {
            result = field.IsUpdate === true;
        }
        return result;
    }
    function submit() {
        if (!checkFieldPermission(serviceInfo?.ServiceType + "Accounting", "Edit")) {
            setErrorDialog(dispatch, "دسترسی مجاز نیست", "ویرایش حسابداری سرویس");
            return;
        }
        submitData.ServiceID = serviceInfo.ServiceID;
        submitData.ServiceType = serviceInfo.ServiceType;
        submitData.MiddlemanCat = serviceInfo.MiddlemanCat;
        submitData.MiddlemanID = serviceInfo.MiddlemanID;
        if (Array.isArray(staffPayments)) {
            submitData.StaffPayments = [...staffPayments];
        }
        if (Number(submitData.TargetAccountID) > 0) {
            serviceInfo.TargetAccountID = submitData.TargetAccountID;
            serviceInfo.TargetAccountCat = submitData.TargetAccountCat;
            serviceInfo.TargetAccountName = targetAccount.AccountName;
        }
        if (Number(submitData.AccountID4Deposit) > 0) {
            serviceInfo.AccountCat4Deposit = submitData.AccountCat4Deposit;
            serviceInfo.AccountID4Deposit = submitData.AccountID4Deposit;
            serviceInfo.AccountName4Deposit = account4Deposit.AccountName;
        }
        serviceInfo.Deposit = submitData.Deposit;
        serviceInfo.CustomerPayment = submitData.CustomerPayment;
        serviceInfo.PaymentDeadline = submitData.PaymentDeadline;
        serviceInfo.MainCompanyAccountTransactionIndex = submitData.MainCompanyAccountTransactionIndex;
        serviceInfo.MainCompanyPaymentStaffShare = submitData.MainCompanyPaymentStaffShare;
        serviceInfo.AmountMainCompanyPays = submitData.AmountMainCompanyPays;
        serviceInfo.MainCompanyID = submitData.MainCompanyID;
        serviceInfo.Discount = submitData.Discount;
        serviceInfo.TaxAmount = submitData.TaxAmount;
        serviceInfo.AmountCustomerShouldPay = submitData.AmountCustomerShouldPay;
        serviceInfo.MiddlemanShare = submitData.MiddlemanShare;
        setServiceInfo({ ...serviceInfo });
        dispatch(updateServicePayments(submitData));
    }
    function updateSubmitData(name, value) {
        if (!value || value === "" || Number(serviceInfo?.AmountCustomerShouldPay ?? 0) === 0) {
            value = 0;
        }
        submitData[name] = Number(value);
        submitData.AmountCustomerShouldPay = submitData.InitPay + Number(submitData.TaxAmount ?? 0) - Number(submitData.Discount ?? 0);
        setSubmitData({ ...submitData });
    }
    function showModalAccLevel3(e) {
        if (e.key) {
            if (keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const onSetData = (data) => {
            selectTargetAccount(data);
            submitData.TargetAccountID = data?.AccountID;
            submitData.TargetAccountCat = data?.AccountCat;
            setSubmitData({ ...submitData });
        }
        setPopAccLevel3({ show: true, setAccData: onSetData, value: e.key });
    }
    function showModalAccLevel3Deposit(e) {
        if (e.key) {
            if (keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const onSetData = (data) => {
            selectAccount4Deposit(data);
            submitData.AccountID4Deposit = data?.AccountID;
            submitData.AccountCat4Deposit = data?.AccountCat;
            setSubmitData({ ...submitData });

        }
        setPopAccLevel3({ show: true, setAccData: onSetData, value: e.key });
    }
    function onPriceChanged(name, value) {
        value = Number(value ?? 0);
        if (name === "StaffShare") {
            setSubmitData({ ...submitData, MainCompanyPaymentStaffShare: value });
            return;
        }
        const staffShare = getStaffShare(staffSharesInfo, "mainCo", 0, value, systemSettings, serviceInfo.ReceptionInAgent, serviceInfo.AgencyID);
        submitData.AmountMainCompanyPays = value;
        setSubmitData({ ...submitData, MainCompanyPaymentStaffShare: staffShare });
    }
    function archive() {
        if (serviceInfo.ServiceID !== "0" && serviceInfo?.IsArchive) {
            setErrorDialog(dispatch, "این سرویس پیش از این بایگانی شده است", "بایگانی سرویس");
            return;
        }
        if (serviceInfo.ServiceID !== "0" && serviceInfo?.IsNotInLastDuration) {
            setErrorDialog(dispatch, "این سرویس مربوط به دوره مالی قبل است و امکان بایگانی آن وجود ندارد", "بایگانی سرویس");
            return;
        }
        dispatch(archiveService(serviceInfo.ServiceType, serviceInfo.ServiceID, () => {
            serviceInfo.IsArchive = true;
            serviceInfo.ArchiveDate = new Date();
            setServiceInfo({ ...serviceInfo });
        }));
    }
    function exitArchive() {
        const onSuccess = (res) => {
            if (!res.Error && res !== "PENDING") {
                serviceInfo.IsArchive = false;
                serviceInfo.ArchiveDate = undefined;
                setServiceInfo({ ...serviceInfo });
                setErrorDialog(dispatch, "success", "خروج از بایگانی");
            }
            else if (res.Error) {
                setErrorDialog(dispatch, res.Error, "خروج از بایگانی");
            }
        }
        removeArchiveService(serviceInfo.ServiceType, serviceInfo.ServiceID, onSuccess)
    }
    function showModalAgencyAccReport() {
        setModalAgencyAccReport({
            show: true,
            agencyID: serviceInfo.AgencyID,
            saleID: serviceInfo.CrossedSaleID,
            serviceType: serviceInfo.ServiceType,
            serviceID: serviceInfo.ServiceID
        })
    }
    function gotoDocument() {
        const onGet = (res) => {
            if (res.DocumentID) {
                window.open(`/Accounting/AddEditDocument/${res.DocumentID}`);
            }
        }
        getDocumentIDByAttachment(serviceInfo.ServiceID, serviceInfo.ServiceType, onGet);
    }
    function showModalMiddleman(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const onSelect = (data) => {
            if (data) {
                setServiceInfo({
                    ...serviceInfo,
                    MiddlemanID: data.ID,
                    MiddlemanName: data.Name,
                    MiddlemanCat: data.Cat
                })
            }
        }
        setPopCustomer({ show: true, value: e.key, invoiceCustomers: true, setCustomerData: onSelect });
    }
    useEffect(() => {
        getMainCompanies(setMainCompanies);
    }, [])
    return (
        <Fragment>
            <ModalAccountLevel3 popData={popAccLevel3} setAccLevel3Popup={setPopAccLevel3} />
            <ModalServiceAgencyAccountReport popData={modalAgencyAccReport} setPopData={setModalAgencyAccReport} />
            <ModalSelectCustomer popData={popCustomer} setCustomerPopup={setPopCustomer} nationalCodeIsRequired={nationalCodeIsRequired} />
            <Row style={{ textAlign: "right", margin: "25px 10px 0 10px" }}>
                <Col md={4} className="rowBorder" style={{ margin: "5px", paddingLeft: "4px", paddingRight: "4px" }}>
                    <div className="rowTitle">تسویه حساب با {Number(serviceInfo.AgencyID) > 0 ? "نماینده" : "مشتری"}</div>
                    <table className="mt-2" style={{ width: "100%" }}>
                        <tbody>
                            <tr>
                                <td>هزینه سرویس: </td>
                                <td><NewNumberInput className="tableRowInput form-control" readonly={true} value={submitData.InitPay - (Number(serviceInfo?.SwapPriceDifference ?? 0) * (serviceInfo?.CustomerInDebtForSwap?.toString() === "true" ? 1 : -1))} /></td>
                            </tr>
                            <tr>
                                <td>تخفیف: </td>
                                <td><NewNumberInput className="tableRowInput" onChange={(e) => updateSubmitData("Discount", e.target.value)} value={submitData.Discount} /></td>
                            </tr>
                            <tr>
                                <td>مالیات: </td>
                                <td><NewNumberInput className="tableRowInput" onChange={(e) => updateSubmitData("TaxAmount", e.target.value)} value={submitData.TaxAmount} /></td>
                            </tr>
                            {Number(serviceInfo?.NewProductID) > 0 &&
                                <tr>
                                    <td>هزینه جایگزینی: </td>
                                    <td><NewNumberInput className="tableRowInput" readonly={true} value={serviceInfo?.SwapPriceDifference ?? 0} /></td>
                                    <td style={{ fontWeight: "bold" }}>{serviceInfo?.CustomerInDebtForSwap?.toString() === "true" ? "بدهکار" : "بستانکار"}</td>
                                </tr>
                            }
                            <tr>
                                <td>قابل پرداخت: </td>
                                <td><NewNumberInput className="tableRowInput" readonly={true} value={submitData.AmountCustomerShouldPay} /></td>
                            </tr>
                            <tr>
                                <td> <label className="ellipsisLabel">سررسید پرداخت: </label></td>
                                <td>
                                    <DatePicker name="ServiceDeadline" isGregorian={false} timePicker={false} className="tableRowInput calendarTableRowInput mt-0"
                                        onChange={value => setSubmitData({ ...submitData, PaymentDeadline: value.local("en").format("YYYY-MM-DD") })}
                                        value={submitData.PaymentDeadline ? momentJalaali(submitData.PaymentDeadline) : null} /></td>
                            </tr>
                            {showDocDate &&
                                <tr>
                                    <td> <label className="ellipsisLabel">تاریخ دستی سند حسابداری: </label></td>
                                    <td>
                                        <DatePicker name="ServiceDeadline" isGregorian={false} timePicker={false} className="tableRowInput calendarTableRowInput mt-0"
                                            onChange={value => setSubmitData({ ...submitData, ManualDocDate: value.local("en").format("YYYY-MM-DD") })}
                                            value={submitData.ManualDocDate ? momentJalaali(submitData.ManualDocDate) : null} /></td>
                                </tr>}
                            <tr>
                                <td><label className="ellipsisLabel">دریافتی از مشتری: </label></td>
                                <td><NewNumberInput className="tableRowInput" defaultValue={serviceInfo?.CustomerPayment ?? 0} onChange={e => submitData.CustomerPayment = e.target.value} /></td>
                                <td>
                                    <div>
                                        <input className="tableRowInput" placeholder="حساب مقصد" readOnly value={targetAccount?.AccountName ?? ""} />
                                        <Button className="btn-input-tiny" style={{ top: "2px", left: "2px" }} onClick={showModalAccLevel3}><List size={17} /></Button>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>بیعانه: </td>
                                <td><NewNumberInput className="tableRowInput" defaultValue={serviceInfo?.Deposit ?? 0} onChange={(e) => submitData.Deposit = e.target.value} /></td>
                                <td>
                                    <div>
                                        <input className="tableRowInput" placeholder="حساب مقصد" readOnly value={account4Deposit?.AccountName ?? ""} />
                                        <Button className="btn-input-tiny" style={{ top: "2px", left: "2px" }} onClick={showModalAccLevel3Deposit}><List size={17} /></Button>
                                    </div></td>

                            </tr>
                        </tbody>
                    </table>
                </Col>
                {!fromModal &&
                    <Fragment>
                        <Col md={4} style={{ margin: "5px", paddingLeft: "4px", paddingRight: "4px" }}>
                            <div className="rowBorder" style={{ height: "142px" }}>
                                <div className="rowTitle">تسویه حساب با تکنسین</div>
                                <Table responsive className="mt-3" style={{ padding: "0 5px 0 5px" }}>
                                    <thead>
                                        <tr>
                                            <th style={{ padding: "4px" }}>تکنسین</th>
                                            <th style={{ padding: "4px" }}>سهم تکنسین</th>
                                            <th style={{ padding: "4px" }}>پرداختی به تکنسین</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {staffPayments === "PENDING" &&
                                            <tr>
                                                <td colSpan={3} style={{ width: "100%", textAlign: "center" }}><Loader type="BallTriangle" color="#bb1370" width={25} height={25} /></td>
                                            </tr>}
                                        {staffPayments && Array.isArray(staffPayments) &&
                                            staffPayments.map((pay, i) =>
                                                <tr key={i}>
                                                    <td>{pay.StaffName}</td>
                                                    <td>{pay.StaffTotalShare?.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</td>
                                                    <td>
                                                        <NewNumberInput className="tableRowInput" defaultValue={pay.StaffTotalPayments}
                                                            onChange={e => pay.StaffTotalPayments = Number(e.target.value ?? 0)} />
                                                    </td>
                                                </tr>)
                                        }
                                    </tbody>
                                </Table>
                            </div>
                            <Row className="rowBorder mt-4">
                                <div className="rowTitle">حق معرفی</div>
                                <FormGroup className="col-md-6">
                                    <label className="ellipsisLabel">معرف:</label>
                                    <Form.Control name="MiddlemanName" className="tableRowInput" readOnly value={serviceInfo?.MiddlemanName ?? ""} onKeyDown={showModalMiddleman} />
                                    <Button className="btn-input-tiny" style={{ top: 26 }} onClick={showModalMiddleman}><List size={18} /></Button>
                                </FormGroup>
                                <Col md={6} className="form-group">
                                    <label>حق معرفی:</label>
                                    <NewNumberInput className="tableRowInput" name="MiddlemanShare" onChange={e => submitData.MiddlemanShare = e.target.value} defaultValue={serviceInfo?.MiddlemanShare ?? 0} />
                                </Col>
                            </Row>
                        </Col>

                        <Col md={3} className="rowBorder" style={{ margin: "5px" }}>
                            <div className="rowTitle">شرکت مادر </div>
                            <table className="mt-2" style={{ width: "100%" }}>
                                <tbody>
                                    <tr>
                                        <td>شرکت مادر: </td>
                                        <td>
                                            {mainCompanies === "PENDING" &&
                                                <div className="tableRowInput" style={{ width: "100%" }}>
                                                    <Loader type="BallTriangle" color="#bb1370" width={20} height={20} style={{ display: "inline-block", mmarginRight: "2px" }} /> &nbsp;
                                                    <label style={{ marginTop: "5px" }}>در حال بارگذاری شرکت های مادر</label>
                                                </div>}
                                            {mainCompanies?.Data && Array.isArray(mainCompanies.Data) &&
                                                <select className="tableRowInput" name="MainCompainyID" defaultValue={serviceInfo?.MainCompanyID ?? 0} onChange={e => submitData.MainCompanyID = e.target.value}>
                                                    <option value="">انتخاب کنید</option>
                                                    {mainCompanies.Data.map((mc, i) => <option key={i} value={mc.ID}>{mc.Name}</option>)}
                                                </select>
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>مبلغ: </td>
                                        <td><NewNumberInput className="tableRowInput" defaultValue={serviceInfo?.AmountMainCompanyPays ?? 0} onChange={e => onPriceChanged("MainCoAmount", e.target.value)} /></td>
                                    </tr>
                                    <tr>
                                        <td>وضعیت: </td>
                                        <select className="tableRowInput" defaultValue={serviceInfo?.MainCompanyAccountTransactionIndex} onChange={e => submitData.MainCompanyAccountTransactionIndex = e.target.value}>
                                            <option value={0}>بدهکار ماند</option>
                                            <option value={1}>بستانکار ماند</option>
                                            <option value={2}>بدهکار و تسویه شد</option>
                                            <option value={3}>بستانکار و تسویه شد</option>
                                        </select>
                                    </tr>
                                    <tr>
                                        <td>سهم تکنسین: </td>
                                        <td><NewNumberInput className="tableRowInput" value={submitData.MainCompanyPaymentStaffShare ?? 0}
                                            onChange={e => onPriceChanged("StaffShare", e.target.value)} /></td>
                                    </tr>
                                </tbody>
                            </table>
                        </Col>
                    </Fragment>
                }
                <div>
                    <Button className="group-Btn-large" variant="success" onClick={submit} disabled={serviceInfo?.IsArchive || serviceInfo.StoppedInStatus}><Check2Square size={17} />&nbsp;ثبت اطلاعات</Button>
                    {checkedIn && serviceInfo?.IsArchive !== true && <Button variant="secondary" className="group-Btn-large" onClick={archive} disabled={serviceInfo.StoppedInStatus}><Archive size={17} />&nbsp;  بایگانی سرویس </Button>}
                    {checkedIn && serviceInfo?.IsArchive === true && <Button variant="secondary" className="group-Btn-large" onClick={exitArchive} disabled={serviceInfo.StoppedInStatus}><Archive size={17} />&nbsp;  خروج از بایگانی </Button>}
                    {Number(serviceInfo?.AgencyID) > 0 && <Button variant="info" className="group-Btn-large" onClick={showModalAgencyAccReport}><FileEarmarkEasel size={17} />&nbsp;حساب نماینده</Button>}
                    <Button className="group-Btn-large btn-violet" onClick={gotoDocument}><FileEarmarkPost size={18} />&nbsp;سند حسابداری</Button >
                </div>
            </Row>
        </Fragment>
    )
}
export default ServiceAccountings;